import { usePostApiData } from "shared/datalayer";
import CommonApi from "shared/enums/CommonApi";
import { isRegPortal } from "shared/utils/config";
import { ApiPaymentInitTokenResponse } from "./types";
import ApiPurchaseOrderRefreshRequest from "shared/types/ApiPurchaseOrderRefreshRequest";
import ApiValidateInitTokenResponse from "shared/types/ApiValidateInitTokenResponse";
import { shouldRefreshPageOnError } from "shared/utils/network";

export function useGetPaymentSdkToken(
  registrationParticipantId: string,
  purchaseOrderId: string,
  invoicePayerId?: string,
  successHandler?: (data: ApiPaymentInitTokenResponse) => void,
  errorHandler?: (err: any) => void
) {
  return usePostApiData<ApiPaymentInitTokenResponse, object>(CommonApi.GET_PAYMENT_INIT_TOKEN, {
    clientOptions: {
      params: {
        invoicePayerId: invoicePayerId && isRegPortal ? invoicePayerId : undefined,
        registrationParticipantId: invoicePayerId && isRegPortal ? undefined : registrationParticipantId,
        purchaseOrderId
      }
    },
    onSuccess: data => successHandler?.(data),
    onError: err => errorHandler?.(err)
  });
}

// refetch the purchase order details to compare amount
// used in stripe context only for now when Purchase button is clicked
export function useRefetchPurchaseOrderDetails(onPurchaseOrderVerificationFailure?: () => void) {
  return usePostApiData<ApiValidateInitTokenResponse, ApiPurchaseOrderRefreshRequest>(
    CommonApi.REFETCH_PURCHASE_ORDER_DETAILS,
    {
      onError: err => {
        if (shouldRefreshPageOnError(err)) {
          onPurchaseOrderVerificationFailure?.();
        }
      }
    }
  );
}
